import React, { useEffect, useState } from 'react';
import { Users } from 'lucide-react';
import { motion } from 'framer-motion';
export function LiveVisitors() {
  const [visitors, setVisitors] = useState(32);
  useEffect(() => {
    const interval = setInterval(() => {
      setVisitors(prev => {
        const change = Math.random() > 0.5 ? 1 : -1;
        const next = prev + change;
        if (next > 47) return 47;
        if (next < 32) return 32;
        return next;
      });
    }, 4000);
    return () => clearInterval(interval);
  }, []);
  return <div className="fixed bottom-4 right-4 z-40 bg-white/90 backdrop-blur-sm text-gray-800 px-4 py-2 rounded-full shadow-lg border border-gray-200 flex items-center gap-3" data-id="element-162">
      <div className="relative flex h-3 w-3" data-id="element-163">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" data-id="element-164"></span>
        <span className="relative inline-flex rounded-full h-3 w-3 bg-green-500" data-id="element-165"></span>
      </div>

      <div className="flex items-center gap-2 text-sm font-bold" data-id="element-166">
        <Users className="w-4 h-4 text-gray-500" data-id="element-167" />
        <motion.span key={visitors} initial={{
        opacity: 0.5,
        y: -2
      }} animate={{
        opacity: 1,
        y: 0
      }} className="font-black text-green-600 min-w-[1.5rem] text-center" data-id="element-168">
          {visitors}
        </motion.span>
        <span className="hidden sm:inline text-gray-600" data-id="element-169">
          personas viendo ahora
        </span>
        <span className="sm:hidden text-gray-600" data-id="element-170">viendo</span>
      </div>
    </div>;
}